/**
 * @param {number} a
 * @param {number} b
 */
const numericSort = (a, b) => a - b;


/**
 * @param {number[]} array
 * @param {number} value
 */
const getNextElement = (array, value) => {
  const index = array.indexOf(value);

  if (index === array.length - 1) {
    return null;
  }
  return array[index + 1];
};


/**
 * @param {number[]} array
 * @param {number} value
 */
const getPreviousElement = (array, value) => {
  const index = array.indexOf(value);

  if (index === 0) {
    return null;
  }

  return array[index - 1];
};


/**
 * @param {number[]} array
 * @param {number} value
 */
const getClosestElement = (array, value) => {
  if (array.length === 1) {
    return array[0];
  }

  return array.reduce((prev, curr) => (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev));
};


export default {
  numericSort,
  getPreviousElement,
  getNextElement,
  getClosestElement,
};
